<template>
  <div class="menu-profile" ref="menuProfile">
    <div class="button secondary" @click="toggleMenu">
      <i class="fas fa-wrench"></i>
    </div>
    <div v-if="show" class="menu" @click="show = false">
      <ul>
        <li id="installButton2" style="display:none">Instalar APP</li>
        <router-link
            v-if="checkResource('config')"
            :to="{ name: 'Config', params: {slug: 'account'} }"
          >
          <li>Configurações</li>
        </router-link>
        <router-link
          v-if="checkResource('config')"
          :to="{ name: 'Config', params: {slug: 'account'} }"
        >
          <li>Assinatura</li>
        </router-link>
        <router-link v-if="checkResource('config')"
          :to="{ name: 'Config', params: {slug: 'user'} }"
          >
          <li>Equipe (Usuários)</li>
        </router-link>
        <router-link
          v-if="checkResource('config') && account && account.account_type === 'MANAGER'"
          :to="{ name: 'Config', params: {slug: 'project'} }"
        >
          <li>Projetos (Clientes)</li>
        </router-link>
        <router-link v-if="checkResource('timelinelog')" :to="{ name: 'TimeLineLog' }">
          <li>Anotações</li>
        </router-link>
          <router-link v-if="checkResource('additionalvalue')" :to="{ name: 'AdditionalValue' }">
          <li>Valores Adicionais</li>
        </router-link>
        <router-link :to="{ name: 'Canny' }">
          <li>Sugestões</li>
        </router-link>
        <router-link :to="{ name: 'Affiliate' }">
          <li>Seja um Afiliado</li>
        </router-link>
        <router-link v-if="hasMultipleAccounts" :to="{ name: 'Account' }">
          <li>Trocar de Projeto</li>
        </router-link>
        <li @click="logout()" >Sair</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ProfileMenu",
  props: ["hasMultipleAccounts"],
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  watch: {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  methods: {
    toggleMenu() {
      this.show = !this.show;
    },
    handleClickOutside(event) {
      if (this.$refs.menuProfile && !this.$refs.menuProfile.contains(event.target)) {
        this.show = false;
      }
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ name: "Login" });
    },
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    checkAppInstall() {
        let deferredPrompt;
        window.addEventListener('beforeinstallprompt', (e) => {
            e.preventDefault();
            deferredPrompt = e;
            const installButton = document.getElementById('installButton2');
            installButton.style.display = 'block';

            installButton.addEventListener('click', () => {
                installButton.style.display = 'none';
                deferredPrompt.prompt();
                deferredPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('User accepted the install prompt');
                    } else {
                        console.log('User dismissed the install prompt');
                    }
                    deferredPrompt = null;
                });
            });
        });
    },
  }
};
</script>

<style lang="scss" scoped>

.menu-profile {
  position: relative;
  >.menu {
    position: absolute;
    z-index: 1001;
    top: 55px;
    left: -120px;
    width:180px;
    min-width: 120px;
    background: var(--boxbg);
    min-height: 100px;

    ul {
      list-style: none;
      a {
        color: var(--text);
      }
      li {
        padding: 12px 16px;
        cursor: pointer;
        &:hover {
          background: var(--primary);
          color: #fff;
        }
      }

    }
  }
}

.button.secondary {
    background: none;
    color: var(--primary);
    border: 0px;
    white-space: nowrap;
    padding: 12px 16px;
    font-size: 1.5rem;
    display: inline-block;
    cursor: pointer;
    transition: 0.3s;
    &:hover {
      background: var(--secondary);
      color: #fff !important;
    }
  }

@media screen and (max-width: 1024px) {
}
</style>